// extracted by mini-css-extract-plugin
module.exports = {"share":"Images_share__NAdT9","backArrow":"Images_backArrow__1YYJp"};